import React, { useState } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import DOMPurify from 'dompurify';

export default function CreateAccount() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const baseURL = process.env.REACT_APP_BASE_URL;

    // Regular expression for strong password
    const strongPasswordRegex = /^(?=.*\d)(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/;
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const [isUsernameValid, setIsUsernameValid] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState({
        password: '',
        username: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = DOMPurify.sanitize(value);

        setFormData({
            ...formData,
            [name]: sanitizedValue,
        });

        // Check password validity on change
        if (name === 'password') {
            setIsPasswordValid(strongPasswordRegex.test(value));
        }
        if (name === 'username') {
            setIsUsernameValid(value.length >= 5);
        }
    };

    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate password before submitting
        if (!isPasswordValid) {
            alert('Password should be at least 8 characters long and contain at least one digit, one uppercase letter, and one special character.');
            return;
        }

        if (!isUsernameValid) {
            alert('Username should be at least 5 characters long.');
            return;
        }

        setIsLoading(true);

        try {
            const sanitizedUsername = DOMPurify.sanitize(formData.username, { SAFE_FOR_TEMPLATES: true });
            const sanitizedPassword = DOMPurify.sanitize(formData.password, { SAFE_FOR_TEMPLATES: true });

            const response = await fetch(`${baseURL}/user-register`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    account_type: 0,
                    password: sanitizedPassword,
                    email: sanitizedUsername,
                }),
            });

            const result = await response.json();
            console.log('Response body:', result);
            if (response.ok) {
                const { access_token, refresh_token, user } = result;

                // Store tokens and user ID in localStorage
                localStorage.setItem('access_token', access_token);
                localStorage.setItem('refresh_token', refresh_token);
                localStorage.setItem('userid', user.userid);

                login(); // Call the login function from AuthContext
                navigate('/edit_profile');
            } else {
                setErrorMessage(result.detail || 'Registration Failed');
            }
        } catch (error) {
            setErrorMessage('An error occurred during registration.');
        }
        finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <section className="user-form-part">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-4">
                            <div className="user-form-card">
                                <div className="user-form-title">
                                    <h2>Create Your Account</h2>
                                    <p>Fill out the form to register</p>
                                </div>
                                <div className="user-form-group">
                                    <form onSubmit={handleSubmit} className="user-form">
                                        <div className="form-group">
                                            <input type="email" className="form-control user-email" id="username" name="username" onChange={handleChange} placeholder='Enter Email' required />
                                        </div>
                                        <div className="form-group">
                                            <input type={showPassword ? 'text' : 'password'} id="password" className="form-control" name="password" onChange={handleChange} placeholder='Enter Password' required />
                                            <span className={`far fa-fw ${showPassword ? 'fa-eye' : 'fa-eye-slash'} eye-icon toggle-password`} onClick={togglePasswordVisibility}></span>
                                        </div>
                                        {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}
                                        <div className="col-md-12 text-center">
                                        <button
                                                type="submit"
                                                className='btn-6 view-all-btnn mt-3 text-capitalize'
                                                disabled={isLoading}
                                            >
                                                {isLoading ? <div class="spinner-border" role="status">
                                                    <span class="sr-only">Loading...</span>
                                                </div> : 'Create a New Account'}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="user-form-remind">
                                <p>Already have an account?<NavLink to="/login">Sign In</NavLink></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
